import { Component } from '@angular/core';
import { Banner } from 'src/app/model/shared/banner';
import { NewAPIReferencePage } from 'src/app/model/page/ndc-21-api-ref-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ConfigService } from 'src/app/service/config.service';
import { Entry } from 'contentful';
import htmlTitle from 'src/assets/json/redirects/html-title.json';
import { ModelValidator } from 'src/app/validator/model-validator';
import { documentToHtmlString } from 'src/app/component/card/api-information-card/index';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-ndc-21-api-reference',
  templateUrl: './ndc-21-api-reference.component.html',
  styleUrl: './ndc-21-api-reference.component.scss'
})
export class Ndc21ApiReferenceComponent {
  pageTitle = '';
  banner: Banner = {} as Banner;

  constructor(private contentfulService: ContentfulService, private titleService: Title, private configService: ConfigService) {}
  apiInformation: NewAPIReferencePage = {} as NewAPIReferencePage;

  ngOnInit(): void {
      htmlTitle.filter((title) => {
        if (title.page === 'British-Airways-NDC-Documentation-for-21.3-Pilot-Partners') {
          this.apiInformation.htmlTitle = title.htmlTitle;
        }
      });
      this.apiInformation.tableSections = [];

      if (this.apiInformation.htmlTitle) {
        this.titleService.setTitle(this.apiInformation.htmlTitle);
      }
      const query = { 'fields.title': 'British-Airways-NDC-Documentation-for-21.3-Pilot-Partners' };
      this.contentfulService.getPageContentResponse(query).then((apiRefPageEntries) => {
        this.mapSearchfields(apiRefPageEntries.items);
        apiRefPageEntries.includes.Entry.filter((entry: Entry<any>) => ModelValidator.isBanner(entry)).forEach((entry: Entry<any>) => {
          this.mapEntryToBanner(entry);
          apiRefPageEntries.includes.Entry.filter((entry: Entry<any>) => ModelValidator.isTableSection(entry))
            .forEach((entry: Entry<any>) => {
              this.mapTables(entry);
            });
        });
      })
      .catch((error) => {
        console.error('Error details:', error);
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      });
  }
  
  private mapSearchfields(items: any) {
    this.apiInformation.htmlTitle = items[0].fields.htmlTitle;
  }

  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '';
    }
    return documentToHtmlString(richText);
  }

  private mapTables(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();
    let table = {
      title: pageTitle,
      body: entry.fields['body'] as string,
      order: entry.fields['order'] as number,
      group: entry.fields['group'] as string,
      table: entry.fields['table'] as string,
      heading: entry.fields['heading'] as string,
      url: entry.fields['url'] as string

    };
    this.apiInformation.tableSections.push(table);
    this.apiInformation.tableSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    this.apiInformation.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url

    };
  }

}